import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import QogitaCredentialsTab from "../../Statistics/Credentials/QogitaCredentials";
import KeepaCredentialsTab from "../../Statistics/Credentials/KeepaCredentials";
import QogitaWatchlistTab from "../../Statistics/Tabs/QogitaWatchlistTab";

const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);

const CredentialsPanel = () => {
  const [provider, setProvider] = useState(0);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={provider} onChange={(_, value) => setProvider(value)}>
          <Tab label="Qogita" />
          <Tab label="Keepa" />
        </Tabs>
      </Box>
      <TabPanel value={provider} index={0}>
        <QogitaCredentialsTab />
      </TabPanel>
      <TabPanel value={provider} index={1}>
        <KeepaCredentialsTab />
      </TabPanel>
    </Box>
  );
};

const QogitaWatchlistSection = () => {
  const [section, setSection] = useState(0);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={section} onChange={(_, value) => setSection(value)}>
          <Tab label="Credentials" />
          <Tab label="Watchlist" />
        </Tabs>
      </Box>

      <TabPanel value={section} index={0}>
        <CredentialsPanel />
      </TabPanel>

      <TabPanel value={section} index={1}>
        <QogitaWatchlistTab />
      </TabPanel>
    </Box>
  );
};

export default QogitaWatchlistSection;
